import { Amplify } from 'aws-amplify';
import { DIRECT_CLIENT_ID } from '../../utils/LS-CONSTANT';

// DIRECT LOGIN (WITHOUT DUO)

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: "us-east-1_CUUoG0n1A",
      userPoolClientId: DIRECT_CLIENT_ID,
      loginWith: {
        email: true
      }
    }
  }
});

export const ALLOWED_USER_GROUP = "LS_POWER_BI";
